<script lang='ts'>
import { liveChannel, schedule, user } from '../store';
import type { Session } from "../services";
import { fade } from 'svelte/transition';
// import { useNavigate } from "svelte-navigator";
import { onMount } from 'svelte';
import * as config from '../config.json';

const NotifyBefore = 10 * 60_000;
const NotifyStartingNow = 2 * 60_000;
// In-memory already notified cache
const notified = {}

let id = 0;
let notifications = []

// const navigate = useNavigate();

const close = not => notifications = notifications.filter(n => n !== not);

function closeClick(e, not) {
  e.stopPropagation();
  close(not)
}

function click(not) {
  // Clicking only dismisses now
  // if (!not.target) return;
  // if (not.external) {
  //   window.open(not.target, "_blank");
  // } else {
  //   navigate(not.target);
  // }
  close(not)
}

function createNotification(title, subtitle, target, hideAfter = 3000, external = false) {
  const index = id++;
  notifications = [...notifications, {id: index, title, subtitle, target, external, hideTime: Date.now() + hideAfter}];

  setTimeout(() => {
    notifications = notifications.filter(n => n.id !== index);
  }, hideAfter)
}

onMount(() => {
  schedule.subscribe((sessions: Session[]) => {
    const now = Date.now();
    const startingSoon: Session[] = []
    const startingNow: Session[] = []
    
    sessions.forEach(e => {
      const ts = e.start.getTime()
      if (now >= ts - NotifyBefore && now < ts) startingSoon.push(e)
      else if (now >= ts && now < ts + NotifyStartingNow) startingNow.push(e)
    })

    startingSoon.forEach(e => {
      if (notified[e.id + "soon"]) return;
      notified[e.id + "soon"] = 1;
      // const external = e.liveStream.type === 'zoom';
      // const link = external ? e.liveStream.url : 'show/' + e.id;
      // createNotification(e.title + " starting soon!", link, 15_000, external);
      createNotification(e.name + " starting soon!", "Head to the show when you're ready", 'show/' + e.id, 15_000, false);
    })

    startingNow.forEach(e => {
      if (notified[e.id + "now"]) return;
      notified[e.id + "now"] = 1;
      // const external = e.liveStream.type === 'zoom';
      // const link = external ? e.liveStream.url : 'show/' + e.id;
      // createNotification(e.name + " is live!", link, 15_000, external);
      createNotification(e.name + " is live!", "Head to the show when you're ready", 'show/' + e.id, 15_000, false);
    })
  });

  const sectionName = config.sections.find(s => s.component === 'badges')?.sectionTitle || 'Achievement';
  const unsub = liveChannel.subscribe('user_' + $user.id, $user.token, msg => {
    if (msg.event === 'badge_progress') {
      console.log("Progress not", msg);
      createNotification("You Earned an Achievement!", `Head to the ${sectionName} page to check it out.`, '', 7_000, false);
    }
  });

  return () => {
    unsub();
  }
})
</script>

<div class="notifications">
  {#each notifications as not (not.id)}
    <div class="notification row mb-2" transition:fade on:click={() => click(not)}>
      <span class="material-icons mr-2">notifications</span>
      <div class="col flex-1">
        <div class="title mb-2">{not.title}</div>
        <div class="subtitle">{not.subtitle}</div>
      </div>
      <span class="material-icons" on:click={e => closeClick(e, not)}>close</span>
    </div>
  {/each}
</div>

<style lang="scss">
@import '../util';

.notifications {
  position: fixed;
  top: 50px;
  right: 50px;
  z-index: 1000;

  @include landscape {
    left: 25px;
    right: 25px;
  }
}

.notification {
  width: 556px;
  color: var(--text-secondary);
  background-color: var(--secondary);
  padding: 8px;
  cursor: pointer;

  @include landscape {
    width: unset;
  }
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.subtitle {
  font-size: 12px;
  font-weight: 300;
}
</style>